export default __webpack_public_path__ + "static/media/302-Series-Brass-Regulators.387d47c5.jpg";